module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Italic.1444e0f0.woff";